// // src/components/AccountCreation/Step2_UserDetails.js
// import React, { useState, useEffect } from 'react';
// import { validateToken, callApi } from "../../lib/utils";
// import { MOCK_CORRECT_OTP } from './constants';

// // A comprehensive list of countries for the autocomplete
// const ALL_COUNTRIES = [
//   "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Antigua and Barbuda", "Argentina", "Armenia", "Australia", "Austria", "Azerbaijan",
//   "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bhutan", "Bolivia", "Bosnia and Herzegovina", "Botswana", "Brazil", "Brunei", "Bulgaria", "Burkina Faso", "Burundi",
//   "Cabo Verde", "Cambodia", "Cameroon", "Canada", "Central African Republic", "Chad", "Chile", "China", "Colombia", "Comoros", "Congo, Democratic Republic of the", "Congo, Republic of the", "Costa Rica", "Cote d'Ivoire", "Croatia", "Cuba", "Cyprus", "Czechia",
//   "Denmark", "Djibouti", "Dominica", "Dominican Republic",
//   "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Eswatini", "Ethiopia",
//   "Fiji", "Finland", "France",
//   "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Greece", "Grenada", "Guatemala", "Guinea", "Guinea-Bissau", "Guyana",
//   "Haiti", "Honduras", "Hungary",
//   "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Israel", "Italy",
//   "Jamaica", "Japan", "Jordan",
//   "Kazakhstan", "Kenya", "Kiribati", "Kosovo", "Kuwait", "Kyrgyzstan",
//   "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg",
//   "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Mauritania", "Mauritius", "Mexico", "Micronesia", "Moldova", "Monaco", "Mongolia", "Montenegro", "Morocco", "Mozambique", "Myanmar",
//   "Namibia", "Nauru", "Nepal", "Netherlands", "New Zealand", "Nicaragua", "Niger", "Nigeria", "North Korea", "North Macedonia", "Norway",
//   "Oman",
//   "Pakistan", "Palau", "Palestine State", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Poland", "Portugal",
//   "Qatar",
//   "Romania", "Russia", "Rwanda",
//   "Saint Kitts and Nevis", "Saint Lucia", "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Korea", "South Sudan", "Spain", "Sri Lanka", "Sudan", "Suriname", "Sweden", "Switzerland", "Syria",
//   "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Timor-Leste", "Togo", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Tuvalu",
//   "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States", "Uruguay", "Uzbekistan",
//   "Vanuatu", "Vatican City", "Venezuela", "Vietnam",
//   "Yemen",
//   "Zambia", "Zimbabwe"
// ];

// const Step2_UserDetails = ({ data, setData, nextStep, accessToken, apiParams, setUserAccessToken }) => {
//   const [otp, setOtp] = useState('');
//   const [isOtpSent, setIsOtpSent] = useState(false);
//   const [isOtpVerified, setIsOtpVerified] = useState(false);
//   const [otpError, setOtpError] = useState('');
//   const [isVerifying, setIsVerifying] = useState(false);
//   const [isSendingOtp, setIsSendingOtp] = useState(false);
//   const [sendError, setSendError] = useState('');
//   const [verificationToken, setVerificationToken] = useState(null);
//   const [confirmPassword, setConfirmPassword] = useState('');
//   const [passwordError, setPasswordError] = useState('');
//   const [zipcodeError, setZipcodeError] = useState('');
//   const [showPassword, setShowPassword] = useState(false);
//   const [showConfirmPassword, setShowConfirmPassword] = useState(false);
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   const zipcodePatterns = {
//     'United States': /^\d{5}(-\d{4})?$/,
//     'Canada': /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/,
//   };

//   const validatePassword = (password) => {
//     if (!password) return "Password is required.";
//     if (password.length < 8) return "Password must be at least 8 characters.";
//     if (!/[A-Z]/.test(password)) return "Must contain an uppercase letter.";
//     if (!/[a-z]/.test(password)) return "Must contain a lowercase letter.";
//     if (!/\d/.test(password)) return "Must contain a number.";
//     if (!/[!@#$%^&*]/.test(password)) return "Must contain a special character.";
//     return "";
//   };

//   useEffect(() => {
//     if (data.user.password || confirmPassword) {
//       const validationError = validatePassword(data.user.password);
//       if (validationError) {
//         setPasswordError(validationError);
//       } else if (data.user.password !== confirmPassword) {
//         setPasswordError("Passwords do not match.");
//       } else {
//         setPasswordError("");
//       }
//     }
//   }, [data.user.password, confirmPassword]);

//   useEffect(() => {
//     if (data.user.country && data.user.zipcode) {
//       const pattern = zipcodePatterns[data.user.country];
//       if (pattern && !pattern.test(data.user.zipcode)) {
//         setZipcodeError(`Invalid zip code format for ${data.user.country}.`);
//       } else {
//         setZipcodeError('');
//       }
//     } else {
//       setZipcodeError('');
//     }
//   }, [data.user.country, data.user.zipcode]);

//   const handleUserChange = (e) => {
//     const { name, value } = e.target;
//     setData(prevData => ({ ...prevData, user: { ...prevData.user, [name]: value } }));
//   };

//   const handleOtpChange = (e) => {
//     const value = e.target.value;
//     // Allow only numbers and limit to 6 digits
//     if (/^\d*$/.test(value) && value.length <= 6) {
//       setOtp(value);
//     }
//   };

//   const handleSendOtp = (e) => {
//     e.preventDefault();
//     if (!data.user.email) return;

//     setIsSendingOtp(true);
//     setSendError('');

//     const payload = { emailAddress: data.user.email };
//     const headers = { 'Authorization': `Bearer ${accessToken}` };

//     callApi('/api/public/patient/web/email-validation/start', payload, 'POST', headers)
//       .then(response => {
//         if (response.data.success) {
//           setVerificationToken(response.data.data.token);
//           setIsOtpSent(true);
//         } else {
//           setSendError(response.data.message || 'Failed to send code.');
//         }
//       })
//       .catch(err => {
//         console.error("Failed to send OTP:", err);
//         setSendError(err.message || "An error occurred. Please try again.");
//       })
//       .finally(() => {
//         setIsSendingOtp(false);
//       });
//   };

//   const handleVerifyOtp = (e) => {
//     e.preventDefault();
//     setOtpError('');
//     setIsVerifying(true);

//     // Use the new payload structure
//     const payload = {
//       emailAddress: data.user.email,
//       code: otp,
//       verificationToken: verificationToken
//     };
//     const headers = { 'Authorization': `Bearer ${accessToken}` };

//     callApi('/api/public/patient/web/email-validation/verify', payload, 'POST', headers)
//       .then(response => {
//         if (response.status === 204 || response.data.success) {
//           setIsOtpVerified(true);
//         } else {
//           setOtpError(response.data.message || 'Invalid OTP.');
//         }
//       })
//       .catch(err => {
//         console.error("Email verification failed:", err);
//         setOtpError(err.message || "An error occurred. Please try again.");
//       })
//       .finally(() => {
//         setIsVerifying(false);
//       });
//   };

//   const handleCreateUser = () => {
//     setIsSubmitting(true);
//     const userPayload = {
//       ...data.user,
//       recordId: null,
//       dob: new Date(data.user.dateOfBirth).getTime(),
//       deviceType: apiParams.device_type,
//       enrollmentTypeCode: "ACUMA",
//       diseaseConditions: [{ code: "SD", diseaseConditionTypeCode: "GTCS" }],
//     };

//     const headers = { Authorization: `Bearer ${accessToken}` };

//     callApi("/api/public/patients/new", userPayload, "POST", headers)
//       .then((response) => {
//         if (response.status === 201 || response.data.success) {
//           const newUserData = response.data.data;
//           const newAccessToken = newUserData.token.token;

//           // Create server session before proceeding
//           callApi("/api/create-session", newUserData, "POST")
//             .then((sessionResponse) => {
//               if (sessionResponse.data.success) {
//                 // Session created, now we can proceed
//                 sessionStorage.setItem("newUserData", JSON.stringify(newUserData));
//                 localStorage.setItem("newUserData", JSON.stringify(newUserData));
//                 setUserAccessToken(newAccessToken);
//                 setData((prev) => ({
//                   ...prev,
//                   user: {
//                     ...prev.user,
//                     ...newUserData.patientData,
//                     id: newUserData.id,
//                   },
//                 }));
//                 nextStep();
//               } else {
//                 alert(
//                   "Could not create a session. You may need to log in manually later."
//                 );
//                 // Still proceed, but login might be required later
//                 nextStep();
//               }
//             })
//             .catch((sessionErr) => {
//               console.error("Session creation failed:", sessionErr);
//               alert(
//                 "An error occurred while creating your session. You may need to log in manually."
//               );
//               // Still proceed
//               nextStep();
//             });
//         } else {
//           // Handle user creation failure
//           alert(response.data.message || "Failed to create user account.");
//         }
//       })
//       .catch((err) => {
//         console.error("User creation failed:", err);
//         alert("An error occurred while creating your account.");
//       })
//       .finally(() => {
//         setIsSubmitting(false);
//       });
//   };

//   const isFormValid = () => {
//     const { firstName, lastName, dateOfBirth, gender, country, state, city, address, zipcode, password } = data.user;
//     return firstName && lastName && dateOfBirth && gender !== '' && country && state && city && address && zipcode && password && !passwordError && !zipcodeError;
//   };

//   const isNextDisabled = !isOtpVerified || !isFormValid() || isSubmitting;

//   const renderCountryOptions = () => {
//     if (apiParams.region_code === 'us_ca') {
//       return <>
//         <option value="United States">United States</option>
//         <option value="Canada">Canada</option>
//       </>;
//     }
//     // Filter out US and Canada for the international list
//     const internationalCountries = ALL_COUNTRIES.filter(c => c !== 'United States' && c !== 'Canada');
//     return internationalCountries.map(country => <option key={country} value={country} />);
//   };

//   return (
//     <div className="step-content">
//       <h2 className="step-title text-center">Your Details</h2>
//       {/* <p className="step-subtitle">Provide your personal information and verify your email.</p> */}
//       {isOtpVerified ? (
//         <form>
//           <div className="mb-3"><label className="form-label" htmlFor="email">Email Address</label><div className="input-group"><input type="email" id="email" name="email" value={data.user.email} onChange={handleUserChange} disabled={isOtpSent || isSendingOtp} className="form-control" placeholder="you@example.com" /><button onClick={handleSendOtp} disabled={isOtpSent || isSendingOtp || !data.user.email} className="btn btn-secondary">{isSendingOtp ? 'Sending...' : (isOtpSent ? 'Sent' : 'Send Code')}</button></div>
//             {sendError && <div className="text-danger mt-1 small">{sendError}</div>}
//           </div>
//           {isOtpSent && (
//             <div className="mb-3">
//               <label className="form-label" htmlFor="otp">Verification Code</label>
//               <p className="form-text text-muted">Enter the 6-digit code sent to your email.</p>
//               <input type="text" id="otp" value={otp} onChange={handleOtpChange} className={`form-control ${otpError ? 'is-invalid' : ''}`} placeholder="123456" maxLength="6" />
//               {otpError && <div className="invalid-feedback">{otpError}</div>}
//               <div className="text-end mt-3">
//                 <button onClick={handleVerifyOtp} disabled={isVerifying} className="btn btn-primary">{isVerifying ? 'Verifying...' : 'Verify Email'}</button>
//               </div>
//             </div>
//           )}
//         </form>
//       ) : (
//         <form>
//           <div className="alert alert-success">Email Verified! Please complete your profile.</div>
//           <div className="row g-3">
//             <div className="col-md-6"><label className="form-label" htmlFor="firstName">First Name</label><input type="text" id="firstName" name="firstName" value={data.user.firstName} onChange={handleUserChange} className="form-control" required /></div>
//             <div className="col-md-6"><label className="form-label" htmlFor="lastName">Last Name</label><input type="text" id="lastName" name="lastName" value={data.user.lastName} onChange={handleUserChange} className="form-control" required /></div>
//             <div className="col-md-6"><label className="form-label" htmlFor="dob">Date of Birth</label><input type="date" id="dob" name="dateOfBirth" value={data.user.dateOfBirth} onChange={handleUserChange} className="form-control" required /></div>
//             <div className="col-md-6"><label className="form-label" htmlFor="gender">Gender</label><select id="gender" name="gender" className="form-select" value={data.user.gender} onChange={handleUserChange} required><option value="">Select...</option><option value="M">Male</option><option value="F">Female</option><option value="">Prefer not to say</option></select></div>
//             <div className="col-md-6">
//               <label className="form-label" htmlFor="country">Country / Region</label>
//               <input list="countries" type="text" id="country" name="country" value={data.user.country} onChange={handleUserChange} className="form-control" required />
//               <datalist id="countries">{renderCountryOptions()}</datalist>
//             </div>
//             <div className="col-md-6"><label className="form-label" htmlFor="state">State / County</label><input type="text" id="state" name="state" value={data.user.state} onChange={handleUserChange} className="form-control" required /></div>
//             <div className="col-md-6"><label className="form-label" htmlFor="city">Town / City</label><input type="text" id="city" name="city" value={data.user.city} onChange={handleUserChange} className="form-control" required /></div>
//             <div className="col-md-6"><label className="form-label" htmlFor="address">Street Address</label><input type="text" id="address" name="address" value={data.user.address} onChange={handleUserChange} className="form-control" required /></div>
//             <div className="col-12"><label className="form-label" htmlFor="zipcode">Zip Code</label><input type="text" id="zipcode" name="zipcode" value={data.user.zipcode} onChange={handleUserChange} className="form-control" required />{zipcodeError && <div className="text-danger small mt-1">{zipcodeError}</div>}</div>
//             <div className="col-md-6">
//               <label className="form-label" htmlFor="password">Password</label>
//               <div className="input-group">
//                 <input type={showPassword ? "text" : "password"} id="password" name="password" value={data.user.password} onChange={handleUserChange} className="form-control" required />
//                 <button className="btn btn-outline-secondary" type="button" onClick={() => setShowPassword(!showPassword)}>
//                   <i className={`bi ${showPassword ? 'bi-eye-slash' : 'bi-eye'}`}></i>
//                 </button>
//               </div>
//               {passwordError && passwordError !== "Passwords do not match." && <div className="text-danger small mt-1">{passwordError}</div>}
//             </div>
//             <div className="col-md-6">
//               <label className="form-label" htmlFor="confirmPassword">Confirm Password</label>
//               <div className="input-group">
//                 <input type={showConfirmPassword ? "text" : "password"} id="confirmPassword" name="confirmPassword" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} className="form-control" required />
//                 <button className="btn btn-outline-secondary" type="button" onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
//                   <i className={`bi ${showConfirmPassword ? 'bi-eye-slash' : 'bi-eye'}`}></i>
//                 </button>
//               </div>
//               {passwordError && passwordError === "Passwords do not match." && <div className="text-danger small mt-1">{passwordError}</div>}
//             </div>
//           </div>
//         </form>
//       )}
//       {isOtpVerified && <div className="text-end mt-4"><button onClick={handleCreateUser} className="btn btn-primary" disabled={isNextDisabled}>{isSubmitting ? 'Saving...' : 'Next'}</button></div>}
//     </div>
//   );
// };

// export default Step2_UserDetails;

// src/components/AccountCreation/Step2_UserDetails.js
// src/components/AccountCreation/Step2_UserDetails.js
import React, { useState, useEffect, useMemo } from 'react';
import { validateToken, callApi } from "../../lib/utils";
import { MOCK_CORRECT_OTP } from './constants';
// Import libraries for international zip code validation
import { postcodeValidator, postcodeValidatorExistsForCountry } from 'postcode-validator';
import countries from 'i18n-iso-countries';
// Import the English language data for the country code library
import enLocale from 'i18n-iso-countries/langs/en.json';

// Register the language data for i18n-iso-countries
countries.registerLocale(enLocale);
// A comprehensive list of countries for the autocomplete
const ALL_COUNTRIES = [
  "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Antigua and Barbuda", "Argentina", "Armenia", "Australia", "Austria", "Azerbaijan",
  "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bhutan", "Bolivia", "Bosnia and Herzegovina", "Botswana", "Brazil", "Brunei", "Bulgaria", "Burkina Faso", "Burundi",
  "Cabo Verde", "Cambodia", "Cameroon", "Canada", "Central African Republic", "Chad", "Chile", "China", "Colombia", "Comoros", "Congo, Democratic Republic of the", "Congo, Republic of the", "Costa Rica", "Cote d'Ivoire", "Croatia", "Cuba", "Cyprus", "Czechia",
  "Denmark", "Djibouti", "Dominica", "Dominican Republic",
  "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Eswatini", "Ethiopia",
  "Fiji", "Finland", "France",
  "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Greece", "Grenada", "Guatemala", "Guinea", "Guinea-Bissau", "Guyana",
  "Haiti", "Honduras", "Hungary",
  "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Israel", "Italy",
  "Jamaica", "Japan", "Jordan",
  "Kazakhstan", "Kenya", "Kiribati", "Kosovo", "Kuwait", "Kyrgyzstan",
  "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg",
  "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Mauritania", "Mauritius", "Mexico", "Micronesia", "Moldova", "Monaco", "Mongolia", "Montenegro", "Morocco", "Mozambique", "Myanmar",
  "Namibia", "Nauru", "Nepal", "Netherlands", "New Zealand", "Nicaragua", "Niger", "Nigeria", "North Korea", "North Macedonia", "Norway",
  "Oman",
  "Pakistan", "Palau", "Palestine State", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Poland", "Portugal",
  "Qatar",
  "Romania", "Russia", "Rwanda",
  "Saint Kitts and Nevis", "Saint Lucia", "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Korea", "South Sudan", "Spain", "Sri Lanka", "Sudan", "Suriname", "Sweden", "Switzerland", "Syria",
  "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Timor-Leste", "Togo", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Tuvalu",
  "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States", "Uruguay", "Uzbekistan",
  "Vanuatu", "Vatican City", "Venezuela", "Vietnam",
  "Yemen",
  "Zambia", "Zimbabwe"
];

const PasswordValidator = ({ password }) => {
  const checks = useMemo(() => {
    return {
      length: password.length >= 8,
      uppercase: /[A-Z]/.test(password),
      lowercase: /[a-z]/.test(password),
      number: /\d/.test(password),
      specialChar: /[!@#$%^&*]/.test(password),
    };
  }, [password]);

  const ValidationItem = ({ isValid, text }) => (
    <li className={`validation-item d-flex align-items-center ${isValid ? 'text-success' : 'text-muted'}`}>
      <i className={`bi ${isValid ? 'bi-check-circle-fill' : 'bi-x-circle'} me-2`}></i>
      {text}
    </li>
  );

  return (
    <div className="password-validator mt-2">
      <ul className="list-unstyled mb-0">
        <ValidationItem isValid={checks.length} text="Must be at least 8 characters" />
        <ValidationItem isValid={checks.uppercase} text="Must contain a uppercase letter" />
        <ValidationItem isValid={checks.lowercase} text="Must contain a lowercase letter" />
        <ValidationItem isValid={checks.number} text="Must contain a number" />
        <ValidationItem isValid={checks.specialChar} text="Must contain a special character" />
      </ul>
    </div>
  );
};

const Step2_UserDetails = ({ data, setData, nextStep, accessToken, apiParams, setUserAccessToken, deviceInfo }) => {
  const [otp, setOtp] = React.useState(new Array(6).fill(""));
  const [isOtpSent, setIsOtpSent] = React.useState(false);
  const [isOtpVerified, setIsOtpVerified] = React.useState(false);
  const [otpError, setOtpError] = React.useState('');
  const [isVerifying, setIsVerifying] = React.useState(false);
  const [isSendingOtp, setIsSendingOtp] = React.useState(false);
  const [sendError, setSendError] = React.useState('');
  const [formError, setFormError] = useState('');
  const [verificationToken, setVerificationToken] = React.useState(null);
  const [confirmPassword, setConfirmPassword] = React.useState('');
  const [passwordError, setPasswordError] = React.useState('');
  const [zipcodeError, setZipcodeError] = React.useState('');
  const [showPassword, setShowPassword] = React.useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [streetAddress2, setStreetAddress2] = React.useState('');
  const [emailError, setEmailError] = React.useState('');
  const [countryError, setCountryError] = useState('');
  const [timer, setTimer] = useState(600); // 10 minutes in seconds
  const [isForFamilyMember, setIsForFamilyMember] = useState(false);
  const [subscriberFirstName, setSubscriberFirstName] = useState('');
  const [subscriberLastName, setSubscriberLastName] = useState('');
  const today = new Date().toISOString().split('T')[0];
  const [countrySearchText, setCountrySearchText] = useState(data.user.country || '');
  const [countrySuggestions, setCountrySuggestions] = useState([]);
  const [isCountryListVisible, setIsCountryListVisible] = useState(false);

  useEffect(() => {
    let interval;
    if (isOtpSent && timer > 0) {
      interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [isOtpSent, timer]);

  useEffect(() => {
    const { country, zipcode } = data.user;

    if (!zipcode) {
      setZipcodeError('');
      return;
    }

    const countryCode = countries.getAlpha2Code(country, 'en');
    const isValidCountryCode = postcodeValidatorExistsForCountry(countryCode);


    if (isValidCountryCode) {
      const isValid = postcodeValidator(zipcode, countryCode);
      //console.log("isValid...", isValid)

      if (!isValid) {
        setZipcodeError(`Invalid zip code format for ${country}.`);
      } else {
        setZipcodeError('');
      }
    } else {
      setZipcodeError('');
    }

    //  if (data.user.country && data.user.zipcode) {
    //   const pattern = zipcodePatterns[data.user.country];
    //   if (pattern && !pattern.test(data.user.zipcode)) {
    //     setZipcodeError(`Invalid zip code format for ${data.user.country}.`);
    //   } else {
    //     setZipcodeError('');
    //   }
    // } else {
    //   setZipcodeError('');
    // }
  }, [data.user.country, data.user.zipcode]);

  const validateEmail = (email) => {
    if (!email) {
      setEmailError("Email is required.");
      return false;
    }
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!regex.test(email)) {
      setEmailError("Please enter a valid email address.");
      return false;
    }
    setEmailError("");
    setSendError("");
    return true;
  };

  const availableCountries = useMemo(() => {
    if (apiParams.region_code === 'us_ca') {
      return ["United States", "Canada"];
    }
    if (apiParams.region_code === 'intl') {
      const restricted = ["United States", "Canada", "United Kingdom"];
      return ALL_COUNTRIES.filter(c => !restricted.includes(c));
    }
    if (apiParams.region_code === 'uk') {
      return ["United Kingdom"];
    }
    return [];
  }, [apiParams.region_code]);

  const validateCountry = (country) => {
    if (!country) {
      setCountryError("Country is required.");
      return false;
    }
    if (!availableCountries.includes(country)) {
      setCountryError("Please select a valid country from the list.");
      return false;
    }
    setCountryError("");
    return true;
  };

  const zipcodePatterns = {
    'United States': /^\d{5}(-\d{4})?$/,
    'Canada': /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/,
  };

  const validatePassword = (password) => {
    if (!password) return "Password is required.";
    if (password.length < 8) return "Password must be at least 8 characters.";
    if (!/[A-Z]/.test(password)) return "Must contain an uppercase letter.";
    if (!/[a-z]/.test(password)) return "Must contain a lowercase letter.";
    if (!/\d/.test(password)) return "Must contain a number.";
    if (!/[!@#$%^&*]/.test(password)) return "Must contain a special character.";
    return "";
  };

  // useEffect(() => {
  //   if (data.user.password || confirmPassword) {
  //     const validationError = validatePassword(data.user.password);
  //     if (validationError) {
  //       setPasswordError(validationError);
  //     }
  //     if (confirmPassword && data.user.password !== confirmPassword) {
  //       setPasswordError("Passwords do not match.");
  //     } else {
  //       setPasswordError("");
  //     }
  //   }
  // }, [data.user.password, confirmPassword]);

  useEffect(() => {
    // All password checks are now centralized here.
    const passwordIsValid =
      data.user.password &&
      data.user.password.length >= 8 &&
      /[A-Z]/.test(data.user.password) &&
      /[a-z]/.test(data.user.password) &&
      /\d/.test(data.user.password) &&
      /[!@#$%^&*]/.test(data.user.password);

    if (!data.user.password) {
      setPasswordError("Password is required.");
    } else if (!passwordIsValid) {
      // Set a general error if any of the checklist items are false.
      // The visual checklist will show the user the specific issue.
      setPasswordError("Password does not meet all requirements.");
    } else if (confirmPassword && data.user.password !== confirmPassword) {
      setPasswordError("Passwords do not match.");
    } else {
      setPasswordError(""); // Clear the error if everything is valid.
    }
  }, [data.user.password, confirmPassword]);

  const handleUserChange = (e) => {
    const { name, value } = e.target;

    if (name === 'email') {
      validateEmail(value);
    }
    if (name === 'zipcode') {
      const numericValue = value.replace(/[^a-zA-Z0-9-]/g, '');
      setData(prevData => ({ ...prevData, user: { ...prevData.user, [name]: numericValue } }));
    } else {
      setData(prevData => ({ ...prevData, user: { ...prevData.user, [name]: value } }));
    }
  };

  const handleOtpChange = (element, index) => {
    if (isNaN(element.value)) return false;

    setOtp([...otp.map((d, idx) => (idx === index ? element.value : d))]);

    //Focus next input
    if (element.nextSibling) {
      element.nextSibling.focus();
    }
  };

  const handleSendOtp = (e) => {
    e.preventDefault();
    if (!validateEmail(data.user.email)) return;

    setIsSendingOtp(true);
    setSendError('');
    setTimer(600); // Reset timer on send

    const payload = { emailAddress: data.user.email };
    const headers = { 'Authorization': `Bearer ${accessToken}` };

    callApi('/api/public/patient/web/email-validation/start', payload, 'POST', headers)
      .then(response => {
        if (response.data.success) {
          setVerificationToken(response.data.data.token);
          setIsOtpSent(true);
        } else {
          setSendError(response.data.message || 'Failed to send code.');
        }
      })
      .catch(err => {
        console.error("Failed to send OTP:", err);
        setSendError(err.message || "An error occurred. Please try again.");
      })
      .finally(() => {
        setIsSendingOtp(false);
      });
  };

  const handleVerifyOtp = (e) => {
    e.preventDefault();
    setOtpError('');
    setIsVerifying(true);

    const payload = {
      emailAddress: data.user.email,
      code: otp.join(""),
      verificationToken: verificationToken
    };
    const headers = { 'Authorization': `Bearer ${accessToken}` };

    callApi('/api/public/patient/web/email-validation/verify', payload, 'POST', headers)
      .then(response => {
        if (response.status === 204 || response.data.success) {
          setIsOtpVerified(true);
        } else {
          setOtpError(response.data.message || 'Invalid OTP.');
        }
      })
      .catch(err => {
        console.error("Email verification failed:", err);
        setOtpError(err.message || "An error occurred. Please try again.");
      })
      .finally(() => {
        setIsVerifying(false);
      });
  };

  const handleCreateUser = () => {
    if (!validateCountry(data.user.country)) return;
    setIsSubmitting(true);
    setFormError('');

    const fullAddress = `${data.user.address}${streetAddress2 ? `, ${streetAddress2}` : ''}`;
    const userPayload = {
      ...data.user,
      firstName: !isForFamilyMember ? data.user.firstName : subscriberFirstName,
      lastName: !isForFamilyMember ? data.user.lastName : subscriberLastName,
      gender: data.user.gender !== "null" ? data.user.gender : null,
      address: fullAddress,
      recordId: null,
      dob: new Date(data.user.dateOfBirth).getTime(),
      deviceType: apiParams.device_type,
      regionCode: apiParams.region_code,
      enrollmentTypeCode: "ACUMA",
      diseaseConditions: [{ "code": "SD", "diseaseConditionTypeCode": null }],
      createdBySelf: !isForFamilyMember,
      creatorProfile: {
        firstName: isForFamilyMember ? data.user.firstName : '',
        lastName: isForFamilyMember ? data.user.lastName : ''
      }
    };

    const headers = { 'Authorization': `Bearer ${accessToken}` };

    callApi("/api/public/patients/new", userPayload, "POST", headers)
      .then((response) => {
        if (response.status === 200 || response.data.success) {
          const newUserData = response.data.data;
          const newAccessToken = newUserData.token.token;
          setUserAccessToken(newAccessToken);
          setData((prev) => ({
            ...prev,
            user: {
              ...prev.user,
              ...newUserData.patientData,
              id: newUserData.id,
            },
          }));
          nextStep();

          // callApi("/api/create-session", newUserData, "POST")
          //   .then((sessionResponse) => {
          //     if (sessionResponse.data.success) {
          //       sessionStorage.setItem("newUserData", JSON.stringify(newUserData));
          //       localStorage.setItem("newUserData", JSON.stringify(newUserData));
          //       setUserAccessToken(newAccessToken);
          //       setData((prev) => ({
          //         ...prev,
          //         user: {
          //           ...prev.user,
          //           ...newUserData.patientData,
          //           id: newUserData.id,
          //         },
          //       }));
          //       nextStep();
          //     } else {
          //       //setFormError("Could not create a session. You may need to log in manually later.");
          //       nextStep();
          //     }
          //   })
          //   .catch((sessionErr) => {
          //     console.error("Session creation failed:", sessionErr);
          //     setFormError("An error occurred while creating your session. You may need to log in manually.");
          //     nextStep();
          //   });
        } else {
          setFormError(response.message || "Failed to create user account.");
        }
      })
      .catch((err) => {
        console.error("User creation failed:", err);
        if (err instanceof TypeError && err.message === 'Failed to fetch') {
          setFormError('Could not connect to our servers. Please try again.');
        } else {
          setFormError(err.message || "Failed to create user account.");
        }
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  const isFormValid = () => {
    const { firstName, lastName, dateOfBirth, gender, country, state, city, address, zipcode, password } = data.user;
    let isValid = firstName && lastName && dateOfBirth && gender && country && !countryError && state && city && address && zipcode && password && confirmPassword && !passwordError && !zipcodeError;
    if (isForFamilyMember) {
      isValid = isValid && subscriberFirstName && subscriberLastName;
    }
    return isValid;
  };

  const isNextDisabled = !isOtpVerified || !isFormValid() || isSubmitting;

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
  };

  const handleCountryChange = (e) => {
    const value = e.target.value;
    setCountrySearchText(value);
    setData(prev => ({ ...prev, user: { ...prev.user, country: '' } })); // Clear valid country on change
    setCountryError("Please select a country from the list.");
    if (value) {
      const filtered = availableCountries.filter(c => c.toLowerCase().includes(value.toLowerCase()));
      setCountrySuggestions(filtered);
      setIsCountryListVisible(true);
    } else {
      setCountrySuggestions([]);
      setIsCountryListVisible(false);
    }
  };

  const selectCountry = (country) => {
    setCountrySearchText(country);
    setData(prev => ({ ...prev, user: { ...prev.user, country: country } }));
    validateCountry(country);
    setIsCountryListVisible(false);
    setCountrySuggestions([]);
  };

  // console.log("emailError....", !emailError)
  // console.log("sendError....", !!sendError)
  //console.log("device info...", deviceInfo.device)
  return (
    <div className="step-content">
      <style>{`
                .password-validator .validation-item {
                    font-size: 0.875rem;
                    transition: color 0.3s ease-in-out;
                }
                .password-validator .bi-check-circle-fill {
                    color: #198754; /* Bootstrap success green */
                }
                .password-validator .bi-x-circle {
                    color: #dc3545; /* Bootstrap danger red */
                }
            `}</style>
      <h2 className="step-title text-center">{isOtpVerified ? 'Your Profile' : 'Verify Email & Create Profile'}</h2>
      <p className="step-subtitle text-center" style={{ marginBottom: "2rem" }}>{isOtpVerified ? 'Complete your profile information' : "We'll send you a verification code to confirm your email address and complete creating your profile"}</p>

      {!isOtpVerified ? (
        <div className="mx-auto" style={{ maxWidth: '500px' }}>
          <form>
            <div className="mb-3">
              <label className="form-label fw-bold" htmlFor="email">Email Address <span className="text-danger">*</span></label>
              <input type="email" id="email" name="email" value={data.user.email} onChange={handleUserChange} disabled={isOtpSent} className={`form-control ${emailError ? 'is-invalid' : ''}`} placeholder="you@example.com" required />
              {emailError && <div className="invalid-feedback">{emailError}</div>}
              {sendError && !emailError && <div className="text-danger small mt-1">{sendError}</div>}
            </div>

            {!isOtpSent ? (
              <div className="d-grid gap-2 d-md-flex justify-content-md-center mt-4">
                <button type="button" onClick={handleSendOtp} disabled={isSendingOtp || !data.user.email} className="btn btn-primary">
                  {isSendingOtp ? 'Sending...' : 'Send Verification Code'}
                </button>
              </div>
            ) : (
              <div>
                <label className="form-label fw-bold">Enter Verification Code</label>
                <div className="d-flex justify-content-center gap-2 gap-sm-3 mb-3">
                  {otp.map((value, index) => (
                    <input className="form-control otp-input text-center" type="text" maxLength="1" key={index} value={value} onChange={e => handleOtpChange(e.target, index)} onFocus={e => e.target.select()} />
                  ))}
                </div>
                {otpError && <p className="text-center text-danger small">{otpError}</p>}

                <div className="d-grid gap-2 d-md-flex justify-content-md-center mt-4">
                  <button type="button" onClick={handleVerifyOtp} disabled={isVerifying} className="btn btn-primary">{isVerifying ? 'Verifying...' : 'Verify Email'}</button>
                </div>

                <div className="text-center mt-3">
                  <button type="button" onClick={handleSendOtp} disabled={timer > 0 || isSendingOtp} className="btn btn-link text-decoration-none">
                    <i className="bi bi-arrow-repeat me-1"></i>
                    Resend Code {timer > 0 ? `(${formatTime(timer)})` : ''}
                  </button>
                </div>
              </div>
            )}
          </form>
        </div>
      ) : (
        <form className='user-form' autoComplete="off">
          <div className="alert alert-success">Email address verified. Please complete your profile to place an order.</div>
          {formError && (
            <div className="text-danger mb-3" style={{ fontSize: '16px' }}>
              <i className="bi bi-exclamation-circle-fill me-2" style={{ fontSize: '18px' }}></i>
              {formError}
            </div>
          )}
          <div className="row g-3">
            <div className="col-md-6"><label className="form-label" htmlFor="firstName">First Name <span className="text-danger">*</span></label><input type="text" id="firstName" name="firstName" value={data.user.firstName} onChange={handleUserChange} className="form-control" required /></div>
            <div className="col-md-6"><label className="form-label" htmlFor="lastName">Last Name <span className="text-danger">*</span></label><input type="text" id="lastName" name="lastName" value={data.user.lastName} onChange={handleUserChange} className="form-control" required /></div>
            <div className="col-12">
              <label className="form-label fw-bold">Is this subscription for you or someone in your family?</label>
              <div className="d-flex">
                <div className="form-check me-4">
                  <input className="form-check-input" type="radio" name="userType" id="forMyself" checked={!isForFamilyMember} onChange={() => setIsForFamilyMember(false)} />
                  <label className="form-check-label" htmlFor="forMyself">
                    For myself
                  </label>
                </div>
                <div className="form-check">
                  <input className="form-check-input" type="radio" name="userType" id="forFamilyMember" checked={isForFamilyMember} onChange={() => setIsForFamilyMember(true)} />
                  <label className="form-check-label" htmlFor="forFamilyMember">
                    For someone else
                  </label>
                </div>
              </div>
            </div>
            {isForFamilyMember && (
              <>
                <div className="col-md-6">
                  <label className="form-label" htmlFor="subscriberFirstName">App User's First Name <span className="text-danger">*</span></label>
                  <input type="text" id="subscriberFirstName" name="subscriberFirstName" value={subscriberFirstName} onChange={(e) => setSubscriberFirstName(e.target.value)} className="form-control" required />
                </div>
                <div className="col-md-6">
                  <label className="form-label" htmlFor="subscriberLastName">App User's Last Name <span className="text-danger">*</span></label>
                  <input type="text" id="subscriberLastName" name="subscriberLastName" value={subscriberLastName} onChange={(e) => setSubscriberLastName(e.target.value)} className="form-control" required />
                </div>
              </>
            )}
            <div className="col-md-6"><label className="form-label" htmlFor="dob">Date of Birth <span className="text-danger">*</span></label><input type="date" id="dob" name="dateOfBirth" value={data.user.dateOfBirth} onChange={handleUserChange} className="form-control" max={today} required /></div>
            <div className="col-md-6"><label className="form-label" htmlFor="gender">Gender <span className="text-danger">*</span></label><select id="gender" name="gender" className="form-select" value={data.user.gender} onChange={handleUserChange} required><option value="">Select...</option><option value="M">Male</option><option value="F">Female</option><option value="null">Prefer not to say</option></select></div>
            <div className="col-6"><label className="form-label" htmlFor="address">Street Address 1 <span className="text-danger">*</span></label><input type="text" id="address" name="address" value={data.user.address} onChange={handleUserChange} className="form-control" required /></div>
            <div className="col-6"><label className="form-label" htmlFor="streetAddress2">Street Address 2</label><input type="text" id="streetAddress2" name="streetAddress2" value={streetAddress2} onChange={(e) => setStreetAddress2(e.target.value)} className="form-control" /></div>
            <div className="col-md-6"><label className="form-label" htmlFor="city">Town / City <span className="text-danger">*</span></label><input type="text" id="city" name="city" value={data.user.city} onChange={handleUserChange} className="form-control" required /></div>
            <div className="col-md-6"><label className="form-label" htmlFor="state">State / County <span className="text-danger">*</span></label><input type="text" id="state" name="state" value={data.user.state} onChange={handleUserChange} className="form-control" required /></div>
            {/* <div className="col-md-6 relative">
              <label className="form-label" htmlFor="country">Country / Region <span className="text-danger">*</span></label>
              <input list="countries" type="text" id="country" name="country" value={data.user.country} onChange={handleUserChange} onBlur={(e) => validateCountry(e.target.value)} className={`form-control ${countryError ? 'is-invalid' : ''}`} required />
              <datalist id="countries">{renderCountryOptions()}</datalist>
              {countryError && <div className="invalid-feedback">{countryError}</div>}
            </div> */}
            <div className="col-md-6 position-relative">
              <label className="form-label" htmlFor="country">Country / Region <span className="text-danger">*</span></label>
              <input type="text" id="country" name="country" value={countrySearchText} onChange={handleCountryChange} onFocus={() => setIsCountryListVisible(true)} className={`form-control ${countryError ? 'is-invalid' : ''}`} required autoComplete="off" />
              {isCountryListVisible && (
                <ul className="list-group position-absolute w-100" style={{ zIndex: 1000, maxHeight: '200px', overflowY: 'auto' }}>
                  {countrySuggestions.length > 0 && countrySuggestions.map((c) => <li key={c} onMouseDown={() => selectCountry(c)} className="list-group-item list-group-item-action">{c}</li>)}
                </ul>
              )}
              {countryError && <div className="invalid-feedback">{countryError}</div>}
            </div>
            <div className="col-md-6">
              <label className="form-label" htmlFor="zipcode">Zip Code <span className="text-danger">*</span></label>
              <input type="text" id="zipcode" name="zipcode" value={data.user.zipcode} onChange={handleUserChange} className={`form-control ${zipcodeError ? 'is-invalid' : ''}`} autoComplete="off" required />
              {zipcodeError && <div className="invalid-feedback">{zipcodeError}</div>}
            </div>
            {/* <div className="col-md-6"><label className="form-label" htmlFor="zipcode">Zip Code <span className="text-danger">*</span></label>
              <input type="text" id="zipcode" name="zipcode" value={data.user.zipcode} onChange={handleUserChange} className="form-control" autoComplete="off" required />
              {zipcodeError && <div className="text-danger small mt-1">{zipcodeError}</div>}
            </div> */}
            <div className="col-md-6">
              <label className="form-label" htmlFor="password">Password <span className="text-danger">*</span></label>
              <div className="input-group">
                <input type={showPassword ? "text" : "password"} id="password" name="password" value={data.user.password} onChange={handleUserChange} className="form-control" autoComplete="new-password" required />
                <button className="btn btn-outline-secondary" type="button" onClick={() => setShowPassword(!showPassword)}>
                  <i className={`bi ${showPassword ? 'bi-eye-slash' : 'bi-eye'}`}></i>
                </button>
              </div>
              {/* {passwordError && passwordError !== "Passwords do not match." && <div className="text-danger small mt-1">{passwordError}</div>} */}
              <PasswordValidator password={data.user.password || ''} />
            </div>
            <div className="col-md-6">
              <label className="form-label" htmlFor="confirmPassword">Confirm Password <span className="text-danger">*</span></label>
              <div className="input-group">
                <input type={showConfirmPassword ? "text" : "password"} id="confirmPassword" name="confirmPassword" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} className="form-control" required />
                <button className="btn btn-outline-secondary" type="button" onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                  <i className={`bi ${showConfirmPassword ? 'bi-eye-slash' : 'bi-eye'}`}></i>
                </button>
              </div>
              {passwordError && passwordError === "Passwords do not match." && <div className="text-danger small mt-1">{passwordError}</div>}
            </div>
          </div>
        </form>
      )}
      {isOtpVerified && <div className="d-grid gap-2 d-md-flex justify-content-md-end mt-4"><button onClick={handleCreateUser} className="btn btn-primary" disabled={isNextDisabled}>{isSubmitting ? 'Saving...' : 'CONTINUE'}</button></div>}
    </div>
  );
};

export default Step2_UserDetails;

